
var validateEmail = function (value) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return value.length === 0 || re.test(value);
}

exports.validateEmail = validateEmail;

var validateDollars = function (value) {
    //will accept dollar amounts with two digits after the decimal or no decimal
    //will also accept a number with or without a dollar sign
    var regex = /^\$?[0-9]+(\.[0-9][0-9])?$/;
    return regex.test(value);
}

exports.validateDollars = validateDollars;

var commonValidate = function () {
    //you could do something here that does general validation for any form field
    return true;
}

exports.commonValidate = commonValidate;

//Broadcast tax groups are identified by taxCode; each member row carries a nullable taxType
//(1 = State, 2 = Local). A selection is valid when at least one member is classified as State
//or Local. Unclassified (null) members are ignored, so a group of only State or only Local rows
//- and a single ungrouped tax - remain selectable.
var BROADCAST_TAX_TYPE_STATE = 1;
var BROADCAST_TAX_TYPE_LOCAL = 2;
var BROADCAST_TAX_GROUP_ERROR = 'Broadcast tax group must include at least one State or Local Tax.';

var isBroadcastTaxGroupValid = function (taxCode, taxes) {
    if (!taxCode) return true;

    var groupTaxes = (taxes || []).filter(function (tax) { return tax.taxCode === taxCode; });
    if (groupTaxes.length === 0) return false;

    return groupTaxes.some(function (tax) {
        var taxType = Number(tax.taxType ?? tax.TaxType);
        return taxType === BROADCAST_TAX_TYPE_STATE || taxType === BROADCAST_TAX_TYPE_LOCAL;
    });
}

exports.isBroadcastTaxGroupValid = isBroadcastTaxGroupValid;
exports.BROADCAST_TAX_GROUP_ERROR = BROADCAST_TAX_GROUP_ERROR;
